var Handlebars = require('/app/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\""
    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"progressBar")), depth0))
    + "\" id=\"export-leads-progress-bar\">\n    <div class=\""
    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"progressBarInner")), depth0))
    + "\" id=\"export-leads-progress-bar-inner\"></div>\n    <div class=\""
    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"progressPercentage")), depth0))
    + "\" id=\"export-leads-progress-percentage\">0%</div>\n    <div class=\""
    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"progressName")), depth0))
    + "\" id=\"export-leads-progress-name\"></div>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./components/account/orders/current-order/bitrix-export-leads/progress-bar/template.hbs
// module id = 885
// module chunks = 0